import React, {Component} from "react";
import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Exercise from '../Exercise/Exercise';
//import PaginationWidget from "../UI/PaginationWidget/PaginationWidget";
import classes from './ExercisesList.module.css';
import axios from "axios";
import apiUrl from "../../shared/config";
import AnchorLink from "react-anchor-link-smooth-scroll";

class ExercisesList extends Component {

    state = {
        count: 0,
        authenticated: false,
        patternExercises: []
    };

    componentDidMount() {

        //console.log("In Exercise List mount. Exercise Id: " + this.props.exerciseId);
        const url = apiUrl +'Exercises/getExercises';
        //const quantity = (this.props.isAuthenticated ? this.props.gameList.quantity : this.props.gameList.quantity + 1);
        const params = {
            params: {
                //quantity: quantity,
                //offset: this.props.gameList.offset,
                //game_name_filter: this.props.gameNameFilter,
                //game_description_filter: this.props.gameDescriptionFilter,
                //game_type_ids_array: this.props.gameTypesFilter,
                //game_publisher_ids_array: this.props.gamePublishersFilter,
                //game_developer_ids_array: this.props.gameDevelopersFilter,
                //game_style_id: this.props.gameStyleFilter,
                //start_date: this.props.releaseStartFilter,
                //end_date: this.props.releaseEndFilter,
                //keyword_ids_array: this.props.keywordsFilter,
                //author: this.props.authorFilter,
                //order_by: this.props.order_by,
            }
        };
        axios.get(url)
            .then(response => {
                this.setState({patternExercises: response.data.exercises_array});
                //this.setState({count: response.data.game_count});
                //this.props.updateCount(response.data.game_count);
                //this.setState({authenticated: this.props.isAuthenticated});
            }).then(
            this.props.listReloaded()
        );
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //console.log("In Exercise List update. Exercise Id: " + this.props.exerciseId);
        if(
            this.props.reloadList === true //||
            //prevProps.gameList.offset !== this.props.gameList.offset ||
            //prevProps.order_by !== this.props.order_by ||
            //this.props.isAuthenticated !== this.state.authenticated
        ) {
            const url = apiUrl +'Exercises/getExercises';
            //this.setState({authenticated: this.props.isAuthenticated});
            //const quantity = (this.props.isAuthenticated ? this.props.gameList.quantity : this.props.gameList.quantity + 1);
            const params = {
                params: {
                    //quantity: quantity,
                    //offset: this.props.gameList.offset,
                    //game_name_filter: this.props.gameNameFilter,
                    //game_description_filter: this.props.gameDescriptionFilter,
                    //game_type_ids_array: this.props.gameTypesFilter,
                    //game_publisher_ids_array: this.props.gamePublishersFilter,
                    //game_developer_ids_array: this.props.gameDevelopersFilter,
                    //game_style_id: this.props.gameStyleFilter,
                    //start_date: this.props.releaseStartFilter,
                    //end_date: this.props.releaseEndFilter,
                    //keyword_ids_array: this.props.keywordsFilter,
                    //author: this.props.authorFilter,
                    //order_by: this.props.order_by,
                }
            };
            axios.get(url, params)
                .then(response => {
                    this.setState({patternExercises: response.data.exercises_array});
                    //this.setState({count: response.data.game_count});
                    //this.props.updateCount(response.data.game_count);
                })
                .then(
                    this.props.listReloaded()
                );
        }
    }

    render() {
        // let newGameSlug = (
        //     <Col className={classes.GameListCol} key="0">
        //         <Game
        //             selected="NewGameList"
        //             key="0"
        //             name="Add New Game"
        //             description="Open the New Game panel to add a game."
        //             clicked={() => {
        //                 this.props.newGame(null);
        //                 this.props.closeGameDetails();
        //                 this.props.gameSelected(null);
        //             }}
        //         />
        //     </Col>
        // );
        // newGameSlug = (this.props.isAuthenticated ? newGameSlug : '');
        //const quantity = (this.
        // props.isAuthenticated ? this.props.gameList.quantity : this.props.gameList.quantity + 1);

        const patternExercises = this.state.patternExercises.map(exercise => {
            let isSelected = '';
            if(this.props.selectedExerciseId === exercise.exercise_id) {
                isSelected = ' selected';
            }

            return (
                <Col className={classes.ExerciseListCol} key={exercise.exercise_id}>
                    <AnchorLink className="no-link-style" offset='80' href='#exercise-details'>
                        <Exercise
                            selected={isSelected}
                            key={exercise.exercise_id}
                            name={exercise.exercise_name}
                            description={exercise.exercise_description}
                            clicked={
                                () => {
                                    this.props.exerciseSelected(exercise.exercise_id)
                                    this.props.executionSelected(exercise.execution_id)
                                }
                            }
                        />
                    </AnchorLink>
                </Col>
            )
        });

        return (
            <div className={"d-flex "+classes.ExerciseListWrapper}>
                <div className={classes.ExerciseList}>
                    <Container fluid className={classes.ExerciseListContainer} >
                        <Row xs={1} md={2} lg={2} xl={3} >
                            {patternExercises}
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}



export default ExercisesList;